<template>
  <div>
    <div style="margin: 10px 0">
      <el-date-picker
        v-model="startYM"
        type="month"
        value-format="yyyy-MM"
        placeholder="选择开始日期"
      >
      </el-date-picker>
      <el-date-picker
        value-format="yyyy-MM"
        v-model="endYM"
        type="month"
        placeholder="选择结束日期"
      >
      </el-date-picker>
      <tree-select
        class="selTree"
        v-if="orgBack"
        @reset="orgId = ''"
        @treeAll="orgall"
        style="
          width: 294px;
          display: inline-block;
          vertical-align: bottom;
          font-size: 14px;
        "
        placeholder="请输入医院名称"
        :option="orgOption"
      ></tree-select>
      <el-button @click="getpage(1)" size="medium">筛选</el-button>
      <el-button type="primary" @click="addBtn" size="medium">新增</el-button>
      <el-button type="primary" @click="piliangAddBtn" size="medium"
        >批量新增</el-button
      >
      <el-button @click="exportState" type="warning">导出</el-button>
    </div>
    <el-divider></el-divider>
    <div>
      <el-table :data="jigouArr" border>
        <el-table-column align="center" label="机构名称" prop="orgName">
        </el-table-column>
        <el-table-column align="center" label="年份" prop="intyear">
        </el-table-column>
        <el-table-column align="center" label="月份" prop="intmonth">
        </el-table-column>
        <el-table-column align="center" label="下载量" prop="download">
        </el-table-column>
        <el-table-column align="center" label="阅读量" prop="readed">
        </el-table-column>
        <el-table-column align="center" label="访问量" prop="visit">
        </el-table-column>
        <el-table-column align="center" label="操作" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" @click="handleEdit(scope.$index, scope.row)"
              >修改</el-button
            >

            <el-popconfirm
              title="你确定要删除该条目吗？"
              @onConfirm="handleDelete(scope.$index, scope.row)"
            >
              <el-button
                style="margin: 0 10px"
                size="mini"
                type="danger"
                slot="reference"
                >删除</el-button
              >
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <page
      @givePageIndex="getpage"
      :index="page"
      :pageSize="pageSize"
      :total="total"
    ></page>
    <el-dialog title="新增机构" :visible.sync="addDialog" width="50%">
      <el-form :model="addform" label-width="80px" inline size="normal">
        <el-form-item label="机构" required>
          <tree-select
            :treeValue="treeValue"
            @treeAll="treeall"
            style="width: 200px"
            v-if="tree"
            :option="treeOption"
          ></tree-select>
        </el-form-item>
        <el-form-item label="年" required>
          <el-input v-model="addform.intyear"></el-input>
        </el-form-item>
        <el-form-item label="月" required>
          <el-input v-model="addform.intmonth"></el-input>
        </el-form-item>
        <el-form-item label="下载量" required>
          <el-input v-model="addform.download"></el-input>
        </el-form-item>
        <el-form-item label="阅读量" required>
          <el-input v-model="addform.readed"></el-input>
        </el-form-item>
        <el-form-item label="访问量" required>
          <el-input v-model="addform.visit"></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer">
        <el-button @click="addDialog = false">取消</el-button>
        <el-button type="primary" @click="add">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="批量新增" :visible.sync="piliangDialog" width="50%">
      <el-form :model="addform" label-width="80px" inline size="normal">
        <el-form-item label="机构" required>
          <tree-select
            :treeValue="treeValue"
            @treeAll="treeall"
            style="width: 200px"
            v-if="tree"
            :option="treeOption"
          ></tree-select>
        </el-form-item>
        <el-form-item label="开始年月" required>
          <el-date-picker
            value-format="yyyy-MM"
            v-model="piliangAddform.startYM"
            type="month"
            placeholder="选择开始日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="结束年月" required>
          <el-date-picker
            value-format="yyyy-MM"
            v-model="piliangAddform.endYM"
            type="month"
            placeholder="选择结束日期"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>

      <span slot="footer">
        <el-button @click="piliangDialog = false">取消</el-button>
        <el-button type="primary" @click="piliangAdd">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="修改机构" :visible.sync="changeDialog" width="50%">
      <el-form :model="changeform" label-width="80px" inline size="normal">
        <el-form-item label="机构" required>
          <tree-select
            :treeValue="treeValue"
            @treeAll="changetreeall"
            style="width: 200px"
            v-if="tree"
            :option="treeOption"
          ></tree-select>
        </el-form-item>
        <el-form-item label="年" required>
          <el-input v-model="changeform.intyear"></el-input>
        </el-form-item>
        <el-form-item label="月" required>
          <el-input v-model="changeform.intmonth"></el-input>
        </el-form-item>
        <el-form-item label="下载量" required>
          <el-input v-model="changeform.download"></el-input>
        </el-form-item>
        <el-form-item label="阅读量" required>
          <el-input v-model="changeform.readed"></el-input>
        </el-form-item>
        <el-form-item label="访问量" required>
          <el-input v-model="changeform.visit"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="changeDialog = false">取消</el-button>
        <el-button type="primary" @click="changebtn">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import treeSelect from "../../components/treeSelect";
import page from "../../components/pages";
export default {
  components: {
    treeSelect,
    page,
  },

  mounted() {
    // this.load();
    this.init();
    this.$api.structureList().then((res) => {
      // console.log(res)
      if (res.data.code == 200) {
        this.orgBack = true;

        this.orgOption = res.data.data;
      }
    });
  },

  data() {
    return {
      piliangDialog: false,
      startYM: "",
      endYM: "",
      orgBack: false,
      treeValue: null,
      tree: false,
      treeOption: [],
      addDialog: false,
      changeDialog: false,
      dialogVisible: false,
      search: "",
      intyear: "", //当前年
      page: 1,
      pageSize: 12,
      total: 0,
      list: [],
      typeList: [],
      typeValue: "",
      intyear: "",
      orgId: "",
      jigouArr: [],
      addform: {
        startTime: "",
        endTime: "",
        id: "",
        intyear: "",
        intmonth: "",
        visit: "",
        download: "",
        readed: "",
        orgId: "",
        orgName: "",
      },
      piliangAddform: {
        orgId: "",
        startYM: "",
        endYM: "",
      },
      changeform: {},
    };
  },
  methods: {
    load() {
      this.init();
      var lists = {
        pageSize: this.pageSize,
        pageNo: this.page,
        intyear: this.intyear,
        orgId: this.orgId,
        startYM: this.startYM,
        endYM: this.endYM,
      };
      this.$api.jigouTotal(lists).then((res) => {
        if (res.data.code == 200) {
          this.jigouArr = res.data.data.records;
          this.page = res.data.data.current;
          this.pageSize = res.data.data.size;
          this.total = res.data.data.total;
        }
      });
    },
    orgall(x) {
      this.orgId = x.id;
    },
    // 导出
    exportState() {
      this.$api.exportStateTotaljigou(
        this.orgId,
        this.startYM,
        this.endYM,
        "Bearer " + sessionStorage.getItem("access_token")
      );
      // window.open(process.env.VUE_APP_API_URL+'/login-log/export?search='+this.search+'&startTime='+this.startTime+'&endDate='+this.endDate,'_self')
      // this.$api.exportStateLogin(obj).then(res=>{
      //   console.log(res)
      //   const blob = new Blob([res.data],{type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}) // 处理文档流（res.data为返回的文档流）
      //   const fileName = '登录统计' // 下载时的文件名
      //   const elink = document.createElement('a')
      //   elink.download = fileName
      //   elink.style.display = 'none'
      //   elink.href = URL.createObjectURL(blob)
      //   document.body.appendChild(elink)
      //   elink.click()
      //   URL.revokeObjectURL(elink.href) // 释放URL 对象
      //   document.body.removeChild(elink)
      // }).catch(er=>{console.log(er)})
    },

    // 删除
    handleDelete(index, row) {
      this.$api.jigouDelete(row.id).then((res) => {
        if (res.data.code == 200) {
          this.$message({
            type: "success",
            message: "删除成功",
          });
          this.init();
        } else {
          this.$message({
            type: "error",
            message: res.data.message,
          });
        }
      });
    },
    //获取医院信息
    treeall(x) {
      //   console.log(x);
      this.addform.orgId = x.id;
      this.piliangAddform.orgId = x.id;
    },
    changetreeall(x) {
      //   console.log(x);
      this.changeform.orgId = x.id;
    },

    // 修改
    handleEdit(a, b) {
      this.tree = false;
      this.$api.structureList().then((res) => {
        if (res.data.code == 200) {
          this.treeOption = res.data.data;
          this.treeValue = b.orgId;
          this.tree = true;
        }
      });
      this.changeDialog = true;
      this.changeform = b;
    },
    // 修改确定
    changebtn() {
      this.$api.jigouAddAppUser(this.changeform).then((res) => {
        if (res.data.code == 200) {
          this.$message({
            message: res.data.message,
            type: "success",
          });
          this.changeDialog = false;
          this.init();
        } else {
          this.$message({
            message: res.data.message,
            type: "error",
          });
        }
      });
    },
    // 批量新增按钮
    piliangAddBtn() {
      this.tree = null;
      this.piliangDialog = true;
      this.$api.structureList().then((res) => {
        // console.log(res)
        if (res.data.code == 200) {
          this.treeValue = Number(sessionStorage.getItem("orgId"));
          this.tree = true;
          this.treeOption = res.data.data;
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    // 批量新增
    piliangAdd() {
      this.$api.jigoupiliangAddAppUser(this.piliangAddform).then((res) => {
        if (res.data.code == 200) {
          this.$message({
            message: res.data.message,
            type: "success",
          });
          this.piliangDialog = false;
          this.piliangAddform = {};
          this.init();
        } else {
          this.$message({
            message: res.data.message,
            type: "error",
          });
        }
      });
    },
    //新增按钮
    addBtn() {
      this.tree = null;
      this.addDialog = true;
      this.$api.structureList().then((res) => {
        // console.log(res)
        if (res.data.code == 200) {
          this.treeValue = Number(sessionStorage.getItem("orgId"));
          this.tree = true;
          this.treeOption = res.data.data;
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    // 新增
    add() {
      this.$api.jigouAddAppUser(this.addform).then((res) => {
        if (res.data.code == 200) {
          this.$message({
            message: res.data.message,
            type: "success",
          });
          this.addDialog = false;
          this.addform = {};
          this.init();
        } else {
          this.$message({
            message: res.data.message,
            type: "error",
          });
        }
      });
    },
    init() {
      var lists = {
        pageSize: this.pageSize,
        pageNo: this.page,
        intyear: this.intyear,
        orgId: this.orgId,
      };
      this.$api.jigouTotal(lists).then((res) => {
        if (res.data.code == 200) {
          this.jigouArr = res.data.data.records;
          this.page = res.data.data.current;
          this.pageSize = res.data.data.size;
          this.total = res.data.data.total;
        }
      });
    },

    getpage(x) {
      //分页
      console.log(x);
      this.page = x;
      this.init();
    },
  },
};
</script>

<style lang="scss" scoped>
.selTree {
  ::v-deep .vue-treeselect--single .vue-treeselect__input {
    height: 37px;
  }
}
</style>